

// Home Hero Banners

import { CategoryInfoResponse, LangCode, Pager } from "@sgm-frontend/core";

export type HomeMediaSectionCode = 'carousel' | 'offers' | 'grid';

export interface HomeMediaResponse {
  view_type: HomeMediaViewType;
}

export interface HomeMediaViewType {
  desktop: HomeMedia[];
  mobile: HomeMedia[];
}

export interface HomeMedia {
  id: number;
  view_type: string;
  section: HomeMediaSectionCode;
  language: string;
  position: number;
  width: number;
  height: number;
  media_url: string;
  media_link: string;
  title?: string;
  
}

// Home Brands

export interface HomeBrandsResponse extends Pager {
  brandSection: HomeBrandItemResponse[];
}

export interface HomeBrandItemResponse {
  id: number;
  img: string;
  //name?: string;
  //translations: HomeBrandTranslationInfo[];
}
